export default __webpack_public_path__ + "static/media/warning.aa26a28f.svg";